import dayjs from 'dayjs';
import { useEffect, useState } from 'react'
import { firestore } from '../../firebase'
import { SearchOutlined } from '@ant-design/icons'
import { Table, Input, Space, Button, Statistic, Row, Col, Typography, Card, Skeleton } from 'antd'
import { CSVLink } from 'react-csv'
import Highlighter from 'react-highlight-words'
import moment from 'moment'
import DateRangeSelector from '../dateRangeSelector'

const { Title } = Typography

let searchInput = null

const priceChart = [
  { plan_code: 'bi-annual', unit_amount: 1497 },
  { plan_code: 'bi-lifetime', unit_amount: 2497 },
  { plan_code: 'bi-two-year', unit_amount: 1997 },
  { plan_code: 'bi-upsell-annual', unit_amount: 349 },
  { plan_code: 'bi-upsell-lifetime', unit_amount: 495 },
  { plan_code: 'btm-30-day', unit_amount: 30 },
  { plan_code: 'btm-alli', unit_amount: 4997 },
  { plan_code: 'btm-alli-full', unit_amount: 9997 },
  { plan_code: 'btm-alli-lifetime-500-credit', unit_amount: 4497 },
  { plan_code: 'btm-alli-lifetime-500-credit-v2', unit_amount: 4497 },
  { plan_code: 'btm-alli-lifetime-special', unit_amount: 1000 },
  { plan_code: 'btm-annual-19', unit_amount: 19 },
  { plan_code: 'btm-annual-19-yt', unit_amount: 19 },
  { plan_code: 'btm-annual-199', unit_amount: 199 },
  { plan_code: 'btm-bronze', unit_amount: 49 },
  { plan_code: 'btm-bronze-49', unit_amount: 49 },
  { plan_code: 'btm-bronze-49-meta', unit_amount: 49 },
  { plan_code: 'btm-lifetime', unit_amount: 199 },
  { plan_code: 'btm-lifetime-199', unit_amount: 199 },
  { plan_code: 'btm-lifetime-199-meta', unit_amount: 199 },
  { plan_code: 'btm-lifetime-199-yt', unit_amount: 199 },
  { plan_code: 'btm-lifetime-297', unit_amount: 297 },
  { plan_code: 'btm-lifetime-99', unit_amount: 99 },
  { plan_code: 'btm-lifetime-black-friday', unit_amount: 99 },
  { plan_code: 'btm-platinum', unit_amount: 79 },
  { plan_code: 'btm-platinum-9', unit_amount: 9 },
  { plan_code: 'btm-platinum-99', unit_amount: 99 },
  { plan_code: 'btm-platinum-99-meta', unit_amount: 99 },
  { plan_code: 'btm-second-year', unit_amount: 49 },
  { plan_code: 'btm-silver', unit_amount: 79 },
  { plan_code: 'btm-silver-99', unit_amount: 99 },
  { plan_code: 'btm-two-year-98', unit_amount: 98 },
  { plan_code: 'btm-two-year-98-meta', unit_amount: 98 },
  { plan_code: 'bw-annual', unit_amount: 1497 },
  { plan_code: 'bw-annual-1997', unit_amount: 1997 },
  { plan_code: 'bw-annual-credit', unit_amount: 997 },
  { plan_code: 'bw-annual-free-second-year', unit_amount: 1997 },
  { plan_code: 'bw-lifetime', unit_amount: 2497 },
  { plan_code: 'bw-lifetime-2997', unit_amount: 2997 },
  { plan_code: 'bw-lifetime-credit', unit_amount: 1997 },
  { plan_code: 'bw-lifetime-special', unit_amount: 1000 },
  { plan_code: 'bw-two-year', unit_amount: 1997 },
  { plan_code: 'bw-two-year-2497', unit_amount: 2497 },
  { plan_code: 'bw-two-year-credit', unit_amount: 1497 },
  { plan_code: 'bw-upsell-annual', unit_amount: 349 },
  { plan_code: 'bw-upsell-lifetime', unit_amount: 495 },
  { plan_code: 'comp-bw-30-day', unit_amount: 199 },
  { plan_code: 'hmp-annual', unit_amount: 1497 },
  { plan_code: 'hmp-annual-1997', unit_amount: 1997 },
  { plan_code: 'hmp-annual-1997-free-second-year', unit_amount: 1997 },
  { plan_code: 'hmp-lifetime', unit_amount: 2497 },
  { plan_code: 'hmp-lifetime-2997', unit_amount: 2997 },
  { plan_code: 'hmp-two-year', unit_amount: 1997 },
  { plan_code: 'hmp-two-year-2497', unit_amount: 2497 },
  { plan_code: 'tt-annual', unit_amount: 1497 },
  { plan_code: 'tt-annual-1997', unit_amount: 1997 },
  { plan_code: 'tt-annual-349', unit_amount: 349 },
  { plan_code: 'tt-annual-997', unit_amount: 997 },
  { plan_code: 'tt-annual-free-second-year', unit_amount: 1997 },
  { plan_code: 'tt-lifetime', unit_amount: 2497 },
  { plan_code: 'tt-lifetime-1997', unit_amount: 1997 },
  { plan_code: 'tt-lifetime-2997', unit_amount: 2997 },
  { plan_code: 'tt-lifetime-495', unit_amount: 495 },
  { plan_code: 'tt-six-month', unit_amount: 749 },
  { plan_code: 'tt-two-year', unit_amount: 1997 },
  { plan_code: 'tt-two-year-1497', unit_amount: 1497 },
  { plan_code: 'tt-two-year-2497', unit_amount: 2497 }
]

const TableHistory = () => {

  const [isFetching, setIsFetching] = useState(false)
  const [historyTable, setHistoryTable] = useState([])
  const [searchText, setSearchText] = useState(null)
  const [searchedColumn, setSearchedColumn] = useState(null)
  const [fetchStartDate, setFetchStartDate] = useState(null)
  const [fetchEndDate, setFetchEndDate] = useState(null)
  const [sales, setSales] = useState(0)

  useEffect(() => {

    if (fetchStartDate && fetchEndDate) fetchHistory()

  },[fetchStartDate, fetchEndDate])

  const fetchHistory = async () => {

    setIsFetching(true)

    try {

      // list of conversions
      const res = await firestore.collection('history')
        .where('created_at', '>=', new Date(fetchStartDate.startOf('d').valueOf()))
        .where('created_at', '<=', new Date(fetchEndDate.endOf('d').valueOf()))
        .orderBy('created_at', 'desc')
        .limit(10000)
        .get()

      if (res.empty) return

      let saleCount = 0
      const tableData = res.docs.map((x, i) => {

        saleCount = saleCount += priceChart.find(y => y.plan_code === x.data().product)?.unit_amount || 0

        return {
          ...x.data(),
          key: i,
          email: decodeURIComponent(x.data().email)
        }
      })

      setSales(saleCount)
      setHistoryTable(tableData)

    } catch (error) {

      console.error({error})

    } finally {

      // remove loading
      setIsFetching(false)
    }
  }

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { searchInput = node }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type='primary'
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size='small' style={{ width: 90 }}>
            Reset
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              confirm({ closeDropdown: false })
              setSearchText(selectedKeys[0])
              setSearchedColumn(dataIndex)
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  })

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = clearFilters => {
    clearFilters()
    setSearchText('')
  }

  const columns = [
    {
      width: 150,
      key: 'created_at',
      title: 'Subscription Created',
      dataIndex: 'created_at',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.created_at - b.created_at,
      render: text => `${moment(text?.toDate()).format('MM/DD/YY hh:mm A')}`
    }, {
      width: 150,
      key: 'account_created',
      title: 'Account Created',
      dataIndex: 'account_created',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.account_created - b.account_created,
      render: text => `${moment(text?.toDate()).format('MM/DD/YY hh:mm A')}`
    }, {
      width: 100,
      key: 'is_first_purchase',
      title: 'First Purchase',
      dataIndex: 'is_first_purchase'
    }, {
      width: 250,
      key: 'email',
      title: 'Email',
      dataIndex: 'email',
      ...getColumnSearchProps('email')
    }, {
      width: 125,
      key: 'product',
      title: 'Product',
      dataIndex: 'product',
      filters: [
        {
          text: 'Frontend',
          value: 'Frontend'
        },
        {
          text: 'Backend',
          value: 'Backend'
        }
      ],
      onFilter: (value, record) => {
        if (value === 'Frontend') return record.product.includes('btm')
        if (value === 'Backend') return !record.product.includes('btm')
      }
    }, {
      width: 100,
      key: 'price',
      title: 'Price',
      dataIndex: 'product',
      render: text => `$ ${priceChart.find(x => x.plan_code === text)?.unit_amount || ''}`
    },{
      width: 125,
      key: 'affiliate',
      title: 'Subscription Affiliate',
      dataIndex: 'affiliate',
      ...getColumnSearchProps('affiliate')
    }, {
      width: 125,
      key: 'orginalAffiliate',
      title: 'Original Affiliate',
      dataIndex: 'orginalAffiliate',
      ...getColumnSearchProps('orginalAffiliate')
    }, {
      width: 125,
      key: 'transaction_id',
      title: 'Transaction ID',
      dataIndex: 'transaction_id',
      ...getColumnSearchProps('transaction_id')
    }
  ]

  return (
    <>
      <Title level={2}>Checkout Pages</Title>

      <Row gutter={[16, 16]} justify='end' align='center'>
        <Col sm={8} md={4} >
          <Button
            type='primary'
            loading={isFetching}
            onClick={fetchHistory}
          >
            Refresh Data
          </Button>
        </Col>
      </Row>

      {(isFetching) &&
        <Skeleton active={true} paragraph={{ rows: 1 }} style={{ marginTop: '-1.25rem' }} />
      }

      {!(isFetching) &&
        <Row gutter={[16, 16]} justify='space-between' align='middle'>
          <Col xm={24} sm={16} style={{ display: 'flex', flexDirection: 'column' }}>
            <DateRangeSelector fetchStartDate={fetchStartDate} fetchEndDate={fetchEndDate} onChange={({ startDate, endDate }) => {
              setHistoryTable([])
              setFetchStartDate(startDate)
              setFetchEndDate(endDate)
            }} />
          </Col>
        </Row>
      }

      {historyTable.length > 0 &&
        <Col>
          <Row gutter={[16, 16]} align='middle'>
            <Card variant='borderless'>
              <Statistic title='Records' value={historyTable.length} />
            </Card>
            <Card variant='borderless'>
              <Statistic title='Sales ($)' value={sales} precision={0} />
            </Card>
          </Row>
        </Col>
      }

      <Table
        style={{ paddingTop: 20 }}
        onChange={(pagination, filters, sorter, extra) => setHistoryTable(extra.currentDataSource)}
        loading={isFetching}
        columns={columns}
        dataSource={historyTable}
        scroll={{ x: 1000, y: 460 }}
        size='small'
        title={() => (
          <CSVLink
            filename={'BTM_Transactions.csv'}
            data={historyTable}
            className='btn btn-primary'
          >
            Export to CSV
          </CSVLink>
        )}
      />
    </>
  )
}

export default TableHistory